var map = {
	"./404.svg": "meGU",
	"./add.svg": "TuMq",
	"./apiRecord.svg": "ECT8",
	"./avatarUpload.svg": "L+Td",
	"./back-to-top.svg": "OjpM",
	"./batch-delete.svg": "RUTv",
	"./bug.svg": "Omjj",
	"./chart.svg": "42h+",
	"./check.svg": "DLDc",
	"./checkFail.svg": "dLlC",
	"./clipboard.svg": "fDub",
	"./collect.svg": "Tw70",
	"./component.svg": "QhzR",
	"./cooperation.svg": "2Mqk",
	"./corp.svg": "+tkt",
	"./countTo.svg": "BTNa",
	"./dashboard.svg": "9ya6",
	"./delete-blue.svg": "vUql",
	"./delete.svg": "NUrT",
	"./doctor.svg": "BajG",
	"./documentation.svg": "QUl8",
	"./drag.svg": "pUq1",
	"./edit.svg": "CMb/",
	"./email.svg": "ULWC",
	"./example.svg": "EL2D",
	"./excel.svg": "sWjn",
	"./eye.svg": "ekvI",
	"./form.svg": "qfxb",
	"./guide.svg": "Smtd",
	"./icon.svg": "OpEq",
	"./international.svg": "VUt5",
	"./language.svg": "8Lz/",
	"./link.svg": "sAHT",
	"./list.svg": "8MU1",
	"./lock.svg": "r7Co",
	"./member.svg": "BtLH",
	"./memberUser.svg": "WHMv",
	"./menu-api-app.svg": "7ell",
	"./menu-cost-center.svg": "3WnF",
	"./menu-h5-app.svg": "8m7u",
	"./menu-weixin-app.svg": "yCpm",
	"./menu-zhanghao.svg": "jkCP",
	"./message.svg": "St3G",
	"./money.svg": "NGFH",
	"./nested.svg": "b7U3",
	"./password.svg": "Jtj/",
	"./payAmount.svg": "5snl",
	"./payNum.svg": "W7X4",
	"./people.svg": "G8xD",
	"./peoples.svg": "eh5m",
	"./qq.svg": "g3MA",
	"./question-mark.svg": "1pPq",
	"./question.svg": "fT+F",
	"./rewardAmount.svg": "pL2r",
	"./rewardNum.svg": "m7M+",
	"./right-header-cost-chongzhi.svg": "1Rsc",
	"./right-header-cost-feiyong.svg": "iCrQ",
	"./right-header-cost-xiaofei.svg": "9/80",
	"./right-header-default-avatar.svg": "bSk8",
	"./right-header-logout.svg": "f2T6",
	"./right-header-qiyerenzheng.svg": "QhEj",
	"./right-header-yonghuguanli.svg": "5H29",
	"./right-header-zhanghaoxinxi.svg": "TUkR",
	"./screenFull.svg": "kdnQ",
	"./shoppingCard.svg": "KCQB",
	"./show.svg": "pFXn",
	"./size.svg": "Xj+I",
	"./split-panel.svg": "cqM4",
	"./star.svg": "kI1z",
	"./sticky.svg": "6woY",
	"./success.svg": "cQmE",
	"./system.svg": "SlHp",
	"./tab.svg": "5zN1",
	"./table.svg": "jF5L",
	"./team.svg": "AWrz",
	"./teamApply.svg": "lZB5",
	"./theme.svg": "wXqr",
	"./tinymce.svg": "t673",
	"./treeSelect.svg": "yvNK",
	"./user.svg": "fP5l",
	"./warning.svg": "Mk8d",
	"./wechat.svg": "8do1",
	"./zip.svg": "kNsC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2tc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg nonrecursive \.svg$
// module id = 2tc1
// module chunks = 8